'use strict';

const $ = window.jQuery;

export default class Header {
    constructor() {
        // NEW HEADER 2023
        $('.header-account-deployer').on('click', function (e) {
            e.stopPropagation();

            $('.header-account-deployer, .header-account-menu, .header-search-deployer, .header-search-input, .lang-selector-deployer, .lang-selector-list').removeClass('is-active');

            $(this).toggleClass('is-active');
            $('.header-account-menu').toggleClass('is-active');
        });

        $('.lang-selector-deployer').on('click', function (e) {
            e.stopPropagation();

            $('.header-account-deployer, .header-account-menu, .header-search-deployer, .header-search-input, .lang-selector-deployer, .lang-selector-list').removeClass('is-active');

            $(this).toggleClass('is-active');
            $('.lang-selector-list').toggleClass('is-active');
        });

        $('.header-search-deployer').on('click', function (e) {
            $('.header-account-deployer, .header-account-menu, .header-search-deployer, .header-search-input, .lang-selector-deployer, .lang-selector-list').removeClass('is-active');

            if (!$('.header-search-input').hasClass('is-active')) {
                e.preventDefault();
                $('.header-search-input').addClass('is-active').focus();
            }

            return false;
        });

        // Close items
        $('body').on('click', function () {
            $('.header-account-deployer, .header-account-menu, .header-search-deployer, .header-search-input, .lang-selector-deployer, .lang-selector-list').removeClass('is-active');
        });

        // NEWSROOM HEADER

        // Search
        $('.search-btn').on('click', function (e) {
            e.stopPropagation();

            $('.lang-switcher__list, .header-account__menu, .header-account').removeClass('is-active');
            $('.search-bar').toggleClass('is-active');
            $('.search-form').find('input').focus();
        });

        $('.search-form').find('input').on('click', function (e) {
            e.stopPropagation();
        });

        // Lang switcher
        $('.lang-switcher__current').on('click', function (e) {
            e.stopPropagation();

            $('.search-bar, .header-account__menu, .header-account').removeClass('is-active');
            $('.lang-switcher__list').toggleClass('is-active');
        });

        // Account
        $('.header-account').on('click', function (e) {
            e.stopPropagation();

            $('.search-bar, .lang-switcher__list').removeClass('is-active');
            $(this).toggleClass('is-active');
            $('.header-account__menu').toggleClass('is-active');
        });

        // Close items
        $('body').on('click', function () {
            $('.search-bar, .lang-switcher__list, .header-account__menu, .header-account').removeClass('is-active');
        });
    }
}
